'use strict';

/**
 *
 * @name: nownessApp.pages
 *
 */

import AdminAccessModule from './admin-access/admin-access.module';
import CategoryModule from './category/category.module';
import ErrorModule from './error/error.module';
import HomeModule from './home/home.module';
import MemberModule from './member/member.module';
import MastheadModule from './masthead/masthead.module';
import PicksModule from './picks/picks.module';
import PlaylistModule from './playlist/playlist.module';
import PreviewsModule from './previews/previews.module';
import SocialRedirectsModule from './social-redirects/social-redirects.module';
import RootModule from './root/root.module';
import SeasonsModule from './seasons/seasons.module';
import AwardsModule from './awards/awards.module';
import SeriesModule from './series/series.module';
import StoryModule from './story/story.module';
import SubscriptionsModule from './subscriptions/subscriptions.module';
import TagsModule from './tag/tag.module';
import UcpModule from './ucp/ucp.module';
import UserModule from './user/user.module';
import UtilityModule from './utility/utility.module';

const PagesModule = angular.module('nownessApp.pages', [
  AdminAccessModule,
  CategoryModule,
  ErrorModule,
  HomeModule,
  MemberModule,
  MastheadModule,
  PicksModule,
  PlaylistModule,
  PreviewsModule,
  SocialRedirectsModule,
  RootModule,
  SeasonsModule,
  AwardsModule,
  SeriesModule,
  StoryModule,
  SubscriptionsModule,
  TagsModule,
  UcpModule,
  UserModule,
  UtilityModule
]);

export default PagesModule.name;



// WEBPACK FOOTER //
// ./app/pages/pages.module.js